import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, icons, brandingVariables } from 'smartsuite-ui';

const statusIcons = {
    bad: {
        iconClass: icons.xFilled,
        iconStyles: { color: brandingVariables.error },
    },
    good: {
        iconClass: icons.checkOutlined,
        iconStyles: { color: brandingVariables.success },
    },
    ok: {
        iconClass: icons.warningOutlined,
        iconStyles: { color: brandingVariables.warning },
    },
    unknown: {
        iconClass: icons.dashOutlined,
        iconStyles: { color: brandingVariables.accent4 },
    },
};

export default function StatusIcon({ cellValue }) {
    const { iconClass, iconStyles } =
        statusIcons[cellValue] || statusIcons.unknown;

    return (
        <TableCell>
            <span className={iconClass} style={iconStyles} />
        </TableCell>
    );
}

StatusIcon.propTypes = {
    cellValue: PropTypes.string,
};
